module.exports = __webpack_public_path__ + "img/maestro@2x.ec0573ad.png";